import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";
import { ProjectSubjectForm } from "./components/CreateProjectSubjectModal/CreateProjectSubjectModal.d";

export const generateRemoteUrl = (
  searchQuery: string,
  selectedLanguage: string[],
  selectedStatus: string[],
  selectedAuthors: number[]
) => {
  const filters = [];

  if (searchQuery) filters.push(`search=${searchQuery}`);
  if (selectedLanguage.length) filters.push(`language=${selectedLanguage.join(",")}`);
  if (selectedStatus.length) filters.push(`status=${selectedStatus.join(",")}`);
  if (selectedAuthors.length) filters.push(`author_ids=${selectedAuthors.join(",")}`);

  return `projects/subjects${filters.length ? `?${filters.join("&")}` : ""}`;
};

export const createProjectSubject = (
  payload: ProjectSubjectForm,
  setLoading: Function,
  onSuccess: Function,
  language: string
) => {
  setLoading(true);

  ApiService.post("projects/subjects", payload)
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error creating project subject:", error);
      alert(translate(language, "PAGES.PROJECT_SUBJECTS.ERRORS.CREATE"));
    })
    .finally(() => setLoading(false));
};

export const fetchPrograms = (setPrograms: Function, language: string, setProgramsLoading: Function) => {
  setProgramsLoading(true);
  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((error) => {
      console.error("Error fetching programs:", error);
      alert(translate(language, "PAGES.PROJECT_SUBJECTS.ERRORS.FETCH_PROGRAMS"));
    })
    .finally(() => setProgramsLoading(false));
};
